// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ol.confirm-student-list{max-height:14em;overflow-y:auto}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/add-kids-modal.vue"],"names":[],"mappings":"AACA,wBACC,eAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
